interface ParamsType {
  category: NativeCategory;
  params: {
    value?: string;
  };
}

export type NativeCategory =
  | 'goSymbol'
  | 'goTrade'
  | 'goWithdraw'
  | 'goDeposit'
  | 'goLogin'
  | 'goIdentityVerification'
  | 'goReferral';

interface GoRouterType extends ParamsType {
  params: {
    value?: string;
    network?: string;
    symbol?: string;
    currency?: string;
  };
}

const BlockFinNative = {
  getUa: () => {
    return navigator.userAgent;
  },
  goRouter: (params: GoRouterType) => {
    if (BlockFinNative.isAndroid(BlockFinNative.getUa())) {
      window.android.openNative(JSON.stringify(params));
    } else {
      window.webkit.messageHandlers.openNative.postMessage(JSON.stringify(params));
    }
  },

  showToast: (value: string, type: '0' | '1' | '2' | '3' = '3') => {
    //"0"success "1"error "2"warning "3" info
    if (BlockFinNative.isAndroid(BlockFinNative.getUa())) {
      window.android.openNative(
        JSON.stringify({
          category: 'showToast',
          params: { value: value, type },
        })
      );
    } else {
      window.webkit.messageHandlers.openNative.postMessage(
        JSON.stringify({
          category: 'showToast',
          params: { value: value, type },
        })
      );
    }
  },
  copyText: (value: string) => {
    if (BlockFinNative.isAndroid(BlockFinNative.getUa())) {
      window.android.openNative(
        JSON.stringify({
          category: 'copyText',
          params: { value },
        })
      );
    } else {
      window.webkit.messageHandlers.openNative.postMessage(
        JSON.stringify({
          category: 'copyText',
          params: { value },
        })
      );
    }
  },
  download: (type: 'image' | 'link', value: string) => {
    if (BlockFinNative.isAndroid(BlockFinNative.getUa())) {
      window.android.openNative(
        JSON.stringify({
          category: 'download',
          params: { value, type },
        })
      );
    } else {
      window.webkit.messageHandlers.openNative.postMessage(
        JSON.stringify({
          category: 'download',
          params: { value, type },
        })
      );
    }
  },
  getRequestId: (biz_type: 'activity' | 'reward') => {
    const args = JSON.stringify({
      category: 'setRequestIdWithCookies',
      params: { biz_type },
    });

    if (BlockFinNative.isAndroid(BlockFinNative.getUa())) {
      window.android.openNative(args);
    } else {
      window.webkit.messageHandlers.openNative.postMessage(args);
    }
  },
  getAppVersion: (ua: string) => {
    const reg = /(version)\/([0-9]{1,2}.[0-9]{1,2}.[0-9]{1,2})/g;
    if (reg.exec(ua)) {
      return reg.exec(ua)?.[2];
    } else {
      return '';
    }
  },
  isApp: (ua: string) => {
    const reg = /(env)\/([A-z]{6})/g;
    if (ua.match(reg)) {
      return true;
    } else {
      return false;
    }
  },
  isAndroid: (ua: string) => {
    const reg = /(device)\/android/g;
    if (ua.match(reg)) {
      return true;
    } else {
      return false;
    }
  },
};

export default BlockFinNative;
